var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box",
    transform: "translate(1640 2721.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    transform: "translate(-1645.111 -2726.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13248",
    "data-name": "Group 13248",
    transform: "translate(5 5.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13020",
    "data-name": "Path 13020",
    d: "M11,10.333a.889.889,0,1,0,.889.889A.889.889,0,0,0,11,10.333Zm2.375.222a.668.668,0,1,0,.069,1.333h6.444a.667.667,0,1,0,0-1.333H13.444A.667.667,0,0,0,13.375,10.555ZM11,14.111a.889.889,0,1,0,.889.889A.889.889,0,0,0,11,14.111Zm2.375.222a.668.668,0,0,0,.069,1.333h6.444a.667.667,0,1,0,0-1.333H13.444A.667.667,0,0,0,13.375,14.333ZM11,17.889a.889.889,0,1,0,.889.889A.889.889,0,0,0,11,17.889Zm2.375.222a.668.668,0,1,0,.069,1.333h6.444a.667.667,0,1,0,0-1.333H13.444A.667.667,0,0,0,13.375,18.111Z",
    transform: "translate(-5 -5)",
    fill: "#0083bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Box-2",
    "data-name": "Box",
    transform: "translate(-1640 -2721.58)",
    fill: "none",
    stroke: "#0083bf",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 3,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/Logs.d37ecefe4a8f62bcd4e8de82015a1bdd.svg";
export { ForwardRef as ReactComponent };